angular.module('BillPay')
    .controller('LinkCtrl', function ($scope, $rootScope, $filter, AppStates, Provider) {

        
        
    });
